var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsentApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_4061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 44.6956C24.5 44.6956 40.5 36.6956 40.5 24.6956V10.6956L24.5 4.69556L8.5 10.6956V24.6956C8.5 36.6956 24.5 44.6956 24.5 44.6956Z",
    fill: "#0099FF",
    stroke: "#0099FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 44.6956C24.5 44.6956 40.5 36.6956 40.5 24.6956V10.6956L24.5 4.69556V20.6956V31.6956C24.5 43.6956 24.5 44.6956 24.5 44.6956Z",
    fill: "#3559B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1431 18.8384L22.3217 27.7669L17.8574 23.7085",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_4061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.195557)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsentApproved);
export default __webpack_public_path__ + "static/media/consent-approved.ebe1a382f83ec334a5b10a076af8d1f9.svg";
export { ForwardRef as ReactComponent };